/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyPaymentPreferencesUpdateRequest
 */
export interface ClientCompanyPaymentPreferencesUpdateRequest {
    /**
     * 
     * @type {Currency}
     * @memberof ClientCompanyPaymentPreferencesUpdateRequest
     */
    newCurrencyCode?: Currency;
}

/**
 * Check if a given object implements the ClientCompanyPaymentPreferencesUpdateRequest interface.
 */
export function instanceOfClientCompanyPaymentPreferencesUpdateRequest(value: object): value is ClientCompanyPaymentPreferencesUpdateRequest {
    return true;
}

export function ClientCompanyPaymentPreferencesUpdateRequestFromJSON(json: any): ClientCompanyPaymentPreferencesUpdateRequest {
    return ClientCompanyPaymentPreferencesUpdateRequestFromJSONTyped(json, false);
}

export function ClientCompanyPaymentPreferencesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyPaymentPreferencesUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newCurrencyCode': json['newCurrencyCode'] == null ? undefined : CurrencyFromJSON(json['newCurrencyCode']),
    };
}

export function ClientCompanyPaymentPreferencesUpdateRequestToJSON(value?: ClientCompanyPaymentPreferencesUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newCurrencyCode': CurrencyToJSON(value['newCurrencyCode']),
    };
}

